import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.4026 2.53641C16.9627 2.09638 16.4405 1.74732 15.8658 1.50917C15.291 1.27101 14.675 1.14844 14.0528 1.14844C13.4307 1.14844 12.8146 1.27101 12.2399 1.50917C11.6651 1.74732 11.1429 2.09638 10.7031 2.53641L9.7903 3.44919L8.87751 2.53641C7.98911 1.648 6.78417 1.1489 5.52777 1.1489C4.27138 1.1489 3.06644 1.648 2.17804 2.53641C1.28963 3.42481 0.790527 4.62975 0.790527 5.88615C0.790527 7.14254 1.28963 8.34748 2.17804 9.23589L3.09082 10.1487L9.7903 16.8481L16.4898 10.1487L17.4026 9.23589C17.8426 8.79607 18.1916 8.27386 18.4298 7.6991C18.6679 7.12434 18.7905 6.50829 18.7905 5.88615C18.7905 5.264 18.6679 4.64795 18.4298 4.07319C18.1916 3.49843 17.8426 2.97623 17.4026 2.53641V2.53641Z",
    stroke: "black",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeartIcon',
  props: {
  active: {
    type: Boolean,
    default: false,
  },
  enableClickAnimation: {
    type: Boolean,
    default: false,
  },
  preventClickBehavior: {
    type: Boolean,
    default: false,
  },
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props





const isSmall = ref(false);

function onClick(event) {
  if (props.preventClickBehavior) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onMousedown: _cache[0] || (_cache[0] = ($event: any) => (isSmall.value = true)),
    onMouseup: _cache[1] || (_cache[1] = ($event: any) => (isSmall.value = false)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isSmall.value = false)),
    onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (isSmall.value = true)),
    onTouchend: _cache[4] || (_cache[4] = ($event: any) => (isSmall.value = false)),
    onTouchcancel: _cache[5] || (_cache[5] = ($event: any) => (isSmall.value = false)),
    class: _normalizeClass(["heart-icon", {
      'heart-icon--active': __props.active,
      'heart-icon--small': isSmall.value && __props.enableClickAnimation,
    }]),
    onClick: onClick
  }, _hoisted_2, 34))
}
}

})